module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-image-fill-82c35812.svg";